enum MailNotificationType {

    BOUNCE= 'BOUNCE',
    DELIVERY= 'DELIVERY',
    COMPLAINT= 'COMPLAINT',
}

export default MailNotificationType;